import React, { useEffect } from "react";
import FilterRow from "../../Shared/FilterRow";

const filterTypeMap = {
  dateFilters: "DateRange",
  enumerableFilters: "EnumerableList",
  numeralFilters: "NumberRange",
};

let timeout = 0;

export default ({ _, updateDigitalFilters, metadataFilterCollection }) => {
  useEffect(() => {}, []);

  const onFilterValueChange = (filter) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      updateDigitalFilters({
        filterType: "metadata",
        alias: filter.alias,
        includedInSearch: !filter.includedInSearch,
      });
    }, 500);
  };

  const onFilterValueClick = (filter) => {
    updateDigitalFilters({
      filterType: "metadata",
      alias: filter.alias,
      includedInSearch: true,
    });
  };

  return (
    <div className="metadata-filters flex-grow-1">
      <h6>{_.MetadataFilters}</h6>
      <div className="d-flex flex-wrap filters-list">
        {Object.keys(metadataFilterCollection).map((filterTypeKey) =>
          metadataFilterCollection[filterTypeKey].map((filter, key) => (
            <div className="filter-content" key={`${filterTypeKey}-${key}`}>
              <h6 className={"metadata-filter-title"}>{filter.alias}</h6>
              {(filterTypeKey === "dateFilters" ||
                filterTypeKey === "numeralFilters") && (
                <FilterRow
                  Filter={{
                    ...filter,
                    FilterType: filterTypeMap[filterTypeKey],
                    onChange: () => onFilterValueChange(filter),
                    IsRange: true,
                  }}
                  _={_}
                />
              )}
              {filterTypeKey === "enumerableFilters" && (
                <FilterRow
                  Filter={{
                    ...filter,
                    FilterType: filterTypeMap[filterTypeKey],
                    onClick: () => onFilterValueClick(filter),
                  }}
                  _={_}
                />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
